import React, { useState, useContext } from 'react';import { Form } from 'react-bootstrap';
import { WidgetsContext } from '../../../GlobalContex';
import styles from './NumberControl.module.css';

const NumberControl = props => {
  const [tooltipObject, setTooltipObject] = useState(false);

  const { setActiveWidgetSettingsParams } = useContext(WidgetsContext);

  const handleNumberChange = (typeParams, e) => {
    let checkboxAction = { [typeParams]: e.target.checked };
    let defaultAction = { [typeParams]: Number(e.target.value) };

    let action = e.target.type === 'checkbox' ? checkboxAction : defaultAction;

    setActiveWidgetSettingsParams(action);
  };

  return (
    <Form.Group style={{ position: 'relative' }} className={'mb-3 d-flex'}>
      <div className="col">
        <Form.Label>{props.item.title}</Form.Label>
      </div>
      <div className={"col " + styles.RangeTooltip}>
        <Form.Range
          value={props.value}
          onChange={handleNumberChange.bind(this, props.item.name)}
          onTouchStart={e => setTooltipObject(true)}
          onTouchEnd={e => setTooltipObject(false)}
          onMouseDown={e => setTooltipObject(true)}
          onMouseUp={e => setTooltipObject(false)}
          min={props.item.min ? props.item.min : 0}
          max={props.item.max ? props.item.max : 10}
          step={props.item.step ? props.item.step : 1}
        />
        {tooltipObject && (
          <div className={styles.RangeTooltipInner}>{props.value}</div>
        )}
      </div>
    </Form.Group>
  );
};

export default NumberControl;
